import {
    Box,
    Button,
    Icon,
    Link,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import { MdCloudDownload } from "react-icons/md";
import { useManajemenPengetahuanDaftarPesertaContext } from "../../../controller/admin/manajemen_pengetahuan/daftar-peserta";
import { TbCertificate } from 'react-icons/tb';
interface Props {
    id: number,
    urlSertifikat: string,
    name: string,
}

const ModalSertifikat: React.FC<Props> = ({ id, urlSertifikat, name }) => {
    const {
        setPengetahuanDaftarPeserta,
    } = useManajemenPengetahuanDaftarPesertaContext().dispatch;

    const {
        isOpenModalSertifikat,
    } =
        useManajemenPengetahuanDaftarPesertaContext().state;

    return (
        <>
            <Button
                colorScheme="blue"
                leftIcon={<Icon as={TbCertificate} />}
                onClick={() => setPengetahuanDaftarPeserta('isOpenModalSertifikat', true)}
            >
                Lihat Sertifikat
            </Button>

            <Modal
                isOpen={isOpenModalSertifikat}
                onClose={() => setPengetahuanDaftarPeserta('isOpenModalSertifikat', false)}
                size="6xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader fontSize="xl" fontWeight="bold">
                        Sertifikat Pengetahuan
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody p={0}>
                        <Box px={6}>
                            <iframe
                                title="sertifikat Pengetahuan"
                                src={urlSertifikat}
                                width={'100%'}
                                height={'500'}
                                style={{ borderRadius: '6px' }}
                            />
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            leftIcon={<MdCloudDownload />}
                            colorScheme="yellow"
                            w="full"
                            // isDisabled={isLoadingDownloadSertifikat} // soon
                            // isLoading={isLoadingDownloadSertifikat} // soon
                            // onClick={() => handleDownloadSertifikat(id, urlSertifikat, name)} // soon
                            as={Link}
                            href={urlSertifikat ?? "#"}
                            isExternal
                        >
                            Download
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ModalSertifikat;
